import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PeticionesHttpBackEndService } from '../../@core/mock/peticiones-http-backend.service';
import { Router } from '@angular/router';
import { UtilidadesService } from '../../@core/utils/utilidades.service';
import { Globals } from '../../../global';

@Component({
  selector: 'ngx-proceso-compra',
  templateUrl: './proceso-compra.component.html',
  styleUrls: ['./proceso-compra.component.scss']
})
export class ProcesoCompraComponent implements OnInit {

  Actividad: any;
  contenidoVisible: Boolean = false;
  carritoVacio: Boolean = false;
  parametrosUrl: any;
  parallax: any;
  Carrito: any;
  ProcesoCompra: any;
  PrecioActividad: any;
  PrecioAct:any;
  Usuario: any;
  loading: Boolean = true;
  fecha: any;
  ExitoCompra: Boolean = false;
  MensajeError: String;
  MensajeWarning: String;
  MuestraResultadoPago: Boolean = false;
  CodigoRespuesta: Number;
  MuestraFree:boolean = false;


  constructor(private _http: PeticionesHttpBackEndService, private router: Router, private utilidades: UtilidadesService) { 
    this.Actividad = {Actividad:[]};
    this.ProcesoCompra = {ActividadId:0, Monto:0, EntidadId:0, MetodoPago: "Transferencia", Referencia: ""}
    this.PrecioActividad = "Calculando precio....";
    this.fecha = new Date();
  }

  optionsFormaPago = [
    //{ value: 'Tarjeta', label: 'Tarjeta de crédito', checked: true},
    //{ value: 'Paypal', label: 'Paypal'},
    { value: 'Transferencia', label: 'Transferencia bancaria'},
  ];

  ngOnInit() {
   

    if (localStorage.getItem("C_BUY")){
      
      this.Carrito = JSON.parse(''+localStorage.getItem("C_BUY")+'');
      this._http.getOnePublic("actividad",this.Carrito.ActividadId).subscribe(
        result => {
          this.Actividad = result;
          this._http.getUsuario().subscribe(
            result => {
              this.Usuario = result;
              if (this.Usuario.Entidad._es_socio){
                this.PrecioActividad = this.Actividad.Actividad._precio_socios+"€";
                this.PrecioAct = this.Actividad.Actividad._precio_socios;
                this.ProcesoCompra.Monto = this.Actividad.Actividad._precio_socios;
              }else{
                this.PrecioActividad = this.Actividad.Actividad._precio+"€";
                this.PrecioAct = this.Actividad.Actividad._precio;
                this.ProcesoCompra.Monto = this.Actividad.Actividad._precio;
              }
              this.ProcesoCompra.ActividadId = this.Actividad.Actividad._actividad_id;
              this.ProcesoCompra.EntidadId = this.Usuario.Entidad._entidad_id;
              this.ProcesoCompra.Referencia = "A"+this.fecha.getFullYear()+this.Actividad.Actividad._edicion+this.Actividad.Actividad._actividad_id;
              this.loading = false;
            }
          )
          this.contenidoVisible = true;
        }
      );
    }else{
      this.loading = false;
      this.carritoVacio = true;
    }

  }

  PagarCompra(){   
    let resultado;    
    if (this.ProcesoCompra.MetodoPago == "Paypal" || this.ProcesoCompra.MetodoPago == "Tarjeta"){
      this._http.postRequest("v1/asisteActividad",{Data:this.ProcesoCompra}).subscribe(
        result => {
          resultado = result;
          
          if (resultado.Code == 200){
            window.location.href='http://tpv.'+ Globals.DOMAIN_NAME +'/?ActividadId='+this.ProcesoCompra.ActividadId+'&EntidadId='+this.Usuario.Entidad._entidad_id+'';
            this.ExitoCompra = true;
            localStorage.removeItem('C_BUY');
            return true;
          }else if(resultado.Code == 1001){
            this.ExitoCompra = false;
            this.CodigoRespuesta = resultado.Code;
            this.MensajeWarning = resultado.Mensaje;
            localStorage.removeItem('C_BUY');
            this.utilidades.notificationWarning("Aviso",this.MensajeWarning,"top-left");

          }else{
            this.CodigoRespuesta = resultado.Code;
            this.ExitoCompra = false;
            this.MensajeWarning = resultado.Mensaje;
            localStorage.removeItem('C_BUY');
            this.utilidades.notificationWarning("Aviso",this.MensajeWarning,"top-left");

          }
          this.MuestraResultadoPago = true;
        }
      )
      
      return true;
    } else{
      this._http.postRequest("v1/asisteActividad",{Data:this.ProcesoCompra}).subscribe(
        result => {
          resultado = result;
          if (resultado.Code == 200){
            this.ExitoCompra = true;
            this.CodigoRespuesta = resultado.Code;
            localStorage.removeItem('C_BUY');
          }else if(resultado.Code == 1001){
            this.ExitoCompra = false;
            this.CodigoRespuesta = resultado.Code;
            this.MensajeWarning = resultado.Mensaje;
            localStorage.removeItem('C_BUY');
          }else{
            this.CodigoRespuesta = resultado.Code;
            this.ExitoCompra = false;
            this.MensajeWarning = resultado.Mensaje;
            localStorage.removeItem('C_BUY');
          }
          this.MuestraResultadoPago = true;
          if(!this.ExitoCompra){
            this.utilidades.notificationWarning("Aviso",this.MensajeWarning,"top-left");
          }
        }
      )
      localStorage.removeItem('C_BUY');
      return true;
    }  
  }

  pagarCompraFree(){
    let resultado;
    this.ProcesoCompra.MetodoPago == "Transferencia";
    this._http.postRequest("v1/asisteActividad",{Data:this.ProcesoCompra}).subscribe(
      result => {
        resultado = result;
        if (resultado.Code == 200){
          this.ExitoCompra = true;
          this.CodigoRespuesta = resultado.Code;
          localStorage.removeItem('C_BUY');
        }else if(resultado.Code == 1001){
          this.ExitoCompra = false;
          this.CodigoRespuesta = resultado.Code;
          this.MensajeWarning = resultado.Mensaje;
          localStorage.removeItem('C_BUY');
        }else{
          this.CodigoRespuesta = resultado.Code;
          this.ExitoCompra = false;
          this.MensajeWarning = resultado.Mensaje;
          localStorage.removeItem('C_BUY');
        }
        this.MuestraFree = true;
        if(!this.ExitoCompra){
          this.utilidades.notificationWarning("Aviso",this.MensajeWarning,"top-left");
        }      }
    )
    localStorage.removeItem('C_BUY');
  }

  Terminar(){
    localStorage.removeItem('C_BUY');
    this.router.navigate(['public/inicio']);
  }
  

}
